import { CALL_API } from '../../../middlewares/api';

import { STORAGE_KEY_CF_TOKEN } from '../../../constants/storage';
import { REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN, RESET_LOGIN_FORM } from './constants';

import { updateInfos } from '../../account/actions';
import { fetchEbonPartners } from '../../ebon/actions';
import { forceFetchPartners } from '../../partner/actions';

import { makeActionCreator } from '../../../utils/actionsUtils';

/**
 * Execute un appel AJAX vers le serveur pour faire une demande de login
 * Envoie au serveur le username et le password du membre
 * @param {*JSON} creds les identifiants de connexion du membre, {username: 'michel', password: 'azerty'}
 * @param {function} callback fonction executé lorsque le login à réussit
 */

export const loginUser = (creds, callback) => {
    const cloudflareCaptcha = sessionStorage.getItem(STORAGE_KEY_CF_TOKEN);

    return {
        [CALL_API]: {
            endpoint: '/auth/login',
            types: [REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN],
            body: { ...creds, cloudflareCaptcha },
            successCallback: (response, dispatch) => {
                sessionStorage.removeItem(STORAGE_KEY_CF_TOKEN);
                dispatch(updateInfos(response.payload.user));
                dispatch(forceFetchPartners());
                dispatch(fetchEbonPartners());
                if (callback) {
                    callback();
                }
            },
            errorCallback: () => {
                window.turnstile.reset();
            }
        }
    };
};

export const resetForm = makeActionCreator(RESET_LOGIN_FORM);



// WEBPACK FOOTER //
// ./src/services/authentication/login/actions.js